export var getPopupState = function(state) {
    return state.popup;
};
